import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OpusAgentTurnFileDownloadUrlQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type OpusAgentTurnFileDownloadUrlQuery = { __typename?: 'Query', OpusAgentTurnFileDownloadUrl?: string | null };


export const OpusAgentTurnFileDownloadUrlDocument = gql`
    query OpusAgentTurnFileDownloadUrl($id: UUID!) {
  OpusAgentTurnFileDownloadUrl(id: $id)
}
    `;

/**
 * __useOpusAgentTurnFileDownloadUrlQuery__
 *
 * To run a query within a React component, call `useOpusAgentTurnFileDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpusAgentTurnFileDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpusAgentTurnFileDownloadUrlQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOpusAgentTurnFileDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<OpusAgentTurnFileDownloadUrlQuery, OpusAgentTurnFileDownloadUrlQueryVariables> & ({ variables: OpusAgentTurnFileDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpusAgentTurnFileDownloadUrlQuery, OpusAgentTurnFileDownloadUrlQueryVariables>(OpusAgentTurnFileDownloadUrlDocument, options);
      }
export function useOpusAgentTurnFileDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpusAgentTurnFileDownloadUrlQuery, OpusAgentTurnFileDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpusAgentTurnFileDownloadUrlQuery, OpusAgentTurnFileDownloadUrlQueryVariables>(OpusAgentTurnFileDownloadUrlDocument, options);
        }
export type OpusAgentTurnFileDownloadUrlQueryHookResult = ReturnType<typeof useOpusAgentTurnFileDownloadUrlQuery>;
export type OpusAgentTurnFileDownloadUrlLazyQueryHookResult = ReturnType<typeof useOpusAgentTurnFileDownloadUrlLazyQuery>;
export type OpusAgentTurnFileDownloadUrlQueryResult = Apollo.QueryResult<OpusAgentTurnFileDownloadUrlQuery, OpusAgentTurnFileDownloadUrlQueryVariables>;